// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 

/**
 * Defines the different zones that messages can originate from or be sent to.
 * 
 *  - `website`: A web page in the browser
 *  - `content`: A content script running inside a browser tab
 *  - `background`: A background script running in the browser.
 *  - `native`: A native application that is running in a separate process.
 */
export type NetworkType = "website" | "content" | "background" | "native";